import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { RecordingSummary, RecordingSummaryStatusState } from 'models/recording_summary';

export default function RecordingDetails({ recordingSummary }) {
  if (!recordingSummary || recordingSummary.status.state === '') {
    return null;
  }

  if (recordingSummary.status.state === RecordingSummaryStatusState.FAILED) {
    return (
      <RecordingDetailsContainer>
        <StatusFailed>Unable to create call summary.</StatusFailed>
      </RecordingDetailsContainer>
    );
  }

  if (recordingSummary.status.state === RecordingSummaryStatusState.PENDING) {
    return (
      <RecordingDetailsContainer>
        <StatusPending>Writing call summary ...</StatusPending>
      </RecordingDetailsContainer>
    );
  }

  return <RecordingDetailsContainer>{recordingSummary.summary}</RecordingDetailsContainer>;
}

RecordingDetails.propTypes = {
  recordingSummary: PropTypes.instanceOf(RecordingSummary),
};

const StatusPending = styled.span`
  color: ${p => p.theme.colors.gray600};
`;
const StatusFailed = styled.span`
  color: ${p => p.theme.colors.gray600};
`;
const RecordingDetailsContainer = styled.div`
  padding-top: 12px;
`;
